import { storageSet } from "../utils/localStore";

interface Font {
    size?: number,
    weight?: number,
    color?: string,
}

export interface Theme {
    font: {
        default: Font,
        title: Font,
        text: Font,
    },
    backgroundColor: string,
    foregroundColor: string,
    primaryColor: string,
    borderRadius: string,

}

const themeBase: Theme = {
    font: {
        default: {
            size: 14,
            weight: 700,
            color: '#ffffff',
        },
        title: {
            size: 16,
            weight: 800
        },
        text: {
            size: 14,
            weight: 700,
        }
    },
    backgroundColor: '#13151d',
    foregroundColor: '#1d1f28',
    primaryColor: '#1976d2',
    borderRadius: '10px',
}

const darkTheme = {

}


export function getTheme(): Theme {
    return currentTheme;
}

let currentTheme: Theme = createTheme();
storageSet('backgroundColor', currentTheme.backgroundColor);
storageSet('foregroundColor', currentTheme.foregroundColor);

function createTheme(): Theme {
    return Object.assign(darkTheme, themeBase);
}